// src/services/pdfLoader.js
// Lazily loads the payslip PDF services (BL-085).
//
// jsPDF plus the bundled Inter font blob are ~514 KB gzipped — over half the
// root chunk — and nothing needs them until a user actually generates a
// payslip. Importing them here through import() keeps them in their own chunk,
// fetched on first download.
//
// IMPORTANT: the chunk is served through firebase.json's "**" -> /index.html
// rewrite, so a tab left open across a deploy can request a filename that no
// longer exists and get HTML back where JS was expected. There is no error
// boundary anywhere in src/, so an unhandled rejection here would surface as a
// dead button. Every caller must catch and show PDF_LOAD_ERROR.

export const PDF_LOAD_ERROR =
  'Could not load the PDF generator. Please reload the page and try again.';

export function loadPayslipPdf() {
  return import('./payslipPdfService').then((m) => m.generatePayslipPdf);
}

export function loadBulkPayslipPdf() {
  return import('./payslipBulkPdfService').then((m) => m.generateBulkPayslipPdf);
}

// Returns the module, not one function: the page needs the builder AND the
// filename helper, since it previews before downloading.
export function loadDtrPdf() {
  return import('./dtrPdfService');
}

// Returns the module, not one function: the page needs the builder AND the
// filename helper (PRD_AttendanceSummaryReport C13).
export function loadAttendanceSummaryPdf() {
  return import('./attendanceSummaryPdfService');
}

// The module, not one function: the page needs the builder AND the filename
// helper (PRD_ContributionBasisReport C19).
export function loadContributionBasisPdf() {
  return import('./contributionBasisPdfService');
}

// The module, as above (PRD_LoanRemittanceReport C7).
export function loadLoanRemittancePdf() {
  return import('./loanRemittancePdfService');
}

// The module, as above (PRD_ContributionSchedule).
export function loadContributionSchedulePdf() {
  return import('./contributionSchedulePdfService');
}
